import { Box, Button, Typography, makeStyles, createStyles, Theme } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import { FiMessageCircle } from 'react-icons/fi';

import { monochrome } from '../../theme/styles';
import { NO_MODULE_ACCESS_TEXT } from '../../constants';

const BULLETS = [
  'Separate work from personal life',
  'Control access with confidence',
  'Keep conversation threads organised',
];

interface Props {
  onActivateClick?: () => void;
  canActivate?: boolean;
}

export const ChatSubscriptionUpsellCard: React.FC<Props> = ({ onActivateClick, canActivate = true }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.iconCircle}>
        <FiMessageCircle size={18} className={classes.icon} />
      </Box>

      <Box className={classes.content}>
        <Typography className={classes.heading}>Want more from Vyce Messaging?</Typography>
        <Typography className={classes.subtitle}>Subscribe to chat to your team</Typography>

        <Box className={classes.bullets}>
          {BULLETS.map(bullet => (
            <Box key={bullet} className={classes.bulletRow}>
              <Box className={classes.bulletDot} />
              <Typography className={classes.bulletText}>{bullet}</Typography>
            </Box>
          ))}
        </Box>

        {canActivate ? (
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onActivateClick}>
            Activate now
          </Button>
        ) : (
          <Typography className={classes.contactAdminText}>{NO_MODULE_ACCESS_TEXT}</Typography>
        )}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => {
  const dark = theme.palette.type === 'dark';
  return createStyles({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      gridGap: 12,
      padding: '20px 16px',
      borderBottom: `1px solid ${monochrome.mediumlight}`,
    },
    iconCircle: {
      width: 36,
      height: 36,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: alpha(theme.palette.primary.main, dark ? 0.16 : 0.08),
      flexShrink: 0,
    },
    icon: {
      color: theme.palette.primary.main,
    },
    content: {
      flex: 1,
      minWidth: 0,
    },
    heading: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '19px',
      color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
      marginBottom: 4,
    },
    subtitle: {
      fontSize: '13px',
      color: theme.palette.text.secondary,
      marginBottom: 12,
    },
    bullets: {
      display: 'flex',
      flexDirection: 'column',
      gridGap: 8,
    },
    bulletRow: {
      display: 'flex',
      alignItems: 'center',
      gridGap: 8,
    },
    bulletDot: {
      width: 4,
      height: 4,
      borderRadius: '50%',
      backgroundColor: theme.palette.text.secondary,
      flexShrink: 0,
    },
    bulletText: {
      fontSize: '13px',
      color: theme.palette.text.secondary,
      lineHeight: '19px',
    },
    button: {
      marginTop: 16,
    },
    contactAdminText: {
      fontSize: '13px',
      color: theme.palette.text.secondary,
      marginTop: 16,
    },
  });
});
